/**
 * 公共脚本版本是否满足页面所需最低版本。
 */
const isPointScriptCompatible = (scriptKey) => {
  const version = window[scriptKey];
  return !!(version && version >= 1);
};

export const isV35PointScriptCompatible = () =>
  isPointScriptCompatible('__V35_POINT_SCRIPT__');

export const isV3PointScriptCompatible = () =>
  isPointScriptCompatible('__V3_POINT_SCRIPT__');

export const isV2PointScriptCompatible = () =>
  isPointScriptCompatible('__V2_POINT_SCRIPT__');

export const isV1PointScriptCompatible = () =>
  isPointScriptCompatible('__V1_POINT_SCRIPT__');

export const isV0PointScriptCompatible = () =>
  isPointScriptCompatible('__V0_POINT_SCRIPT__');

export const isCreditPayPointScriptCompatible = () =>
  isPointScriptCompatible('__CREDIT_PAY_POINT_SCRIPT__');
